<div class="item-listing" [attr.data-test]="itemId" tabindex="0">
    <span class="item-main-infos title">{{ item?.documentType }}</span>
    <envelope-status-badge [document]="item"></envelope-status-badge>
    <span class="item-main-infos">{{ item?.documentCategoryName }}</span>
    <span class="item-main-infos">{{ item?.createdDate || '--' }}</span>
    <div class="container-img">
      <a (click)="openDocumentDetails();" role="tooltip" aria-label="Dados do documento" data-microtip-position="top">
        <img class="item-main-infos icon" src="/assets/images/icon-info.svg" alt="Ver envelope"/>
      </a>
      <a *ngIf="!loadingOpenDoc" (click)="openDocumet();" role="tooltip" aria-label="Visualizar" data-microtip-position="top" target="_blank">
        <img class="item-main-infos icon" src="/assets/images/icon-eyes.svg" alt="Visualizar documento"/>
      </a>
      <div *ngIf="loadingOpenDoc" class="item-main-infos loading-wrapper">
        <div *ngIf="loadingOpenDoc" [ngClass]="{ 'loading': loadingOpenDoc }"></div>
      </div>
      <a *ngIf="!loading" (click)="downloadDocumet();" role="tooltip" aria-label="Download" data-microtip-position="top">
        <img class="item-main-infos icon" src="/assets/images/ico-download.svg" alt="Baixar documento"/>
      </a>
      <div *ngIf="loading" class="item-main-infos loading-wrapper">
        <div *ngIf="loading" [ngClass]="{ 'loading': loading, 'last-btn': loading }"></div>
      </div>
    </div>  
</div>
